import React, {Fragment,Component,useState,useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import _ from 'lodash';
import {
  Label,
  Menu,
  Message,
  Form,
  Table,
  Tab,
  Statistic,
  Divider,
  Progress,
  Input, Step, Header,Modal,Dimmer, Loader, Grid, Segment, Item, Image, Popup, Button, Icon, Card} from 'semantic-ui-react';
import { Link } from 'react-router-dom'
import {connect} from 'react-redux';
import ListFactory from '../../components/ListFactory';
import {ts2date,readableMap} from '../../util';

const Balance = (props)=>{

  const [available, setAvailable] = useState(0);
  const [withdrawn, setWithdrawn] = useState(0);
  const [splits,       setSplits] = useState(0);
  const [splits1,     setSplits1] = useState(0);
  const [splits2,     setSplits2] = useState(0);

  useEffect(() => {
    console.log("get check");
    check()
    return ()=>{ }
  }, []);

  const check = async ()=>{
    const {data} = await axios.get('/user/balance');
    const usdt = data.data.filter((i)=>{return i.asset == "usdt"})
    const s1   = data.data.filter((i)=>{return i.business == "system:split:level1"})
    const s2   = data.data.filter((i)=>{return i.business == "system:split:level2"})
    const w    = data.data.filter((i)=>{return i.business == "system:withdraw" && i.asset == "usdt_withdrew"  })

    if(w.length > 0){
      var wsum = _.sumBy(w,(item)=>{return item.change * 1})
      setWithdrawn( Math.round(wsum * 100 )/100 )
    }

    if(s1.length > 0){
      var s1sum = _.sumBy(s1,(item)=>{return item.change * 1})
      setSplits1( Math.round(s1sum * 100 )/100 )
    }

    if(s2.length > 0){
      var s2sum = _.sumBy(s2,(item)=>{return item.change * 1})
      setSplits2( Math.round(s2sum * 100 )/100 )
    }

    if(usdt.length == 0){
      setAvailable(0)
    }else{
      setAvailable( Math.round(usdt[0].balance * 100 )/100 )
      setSplits(usdt.length)
    }
  }

  return (
    <Segment color="green" inverted>
      <Statistic.Group inverted>
        <Statistic>
          <Statistic.Label>USD Balance</Statistic.Label>
          <Statistic.Value>{available}</Statistic.Value>
        </Statistic>
        <Statistic>
          <Statistic.Label>USD Withdrawn</Statistic.Label>
          <Statistic.Value>{withdrawn}</Statistic.Value>
        </Statistic>
        <Statistic>
          <Statistic.Label>Level 1 Splits</Statistic.Label>
          <Statistic.Value>{splits1}</Statistic.Value>
        </Statistic>
        <Statistic>
          <Statistic.Label>Level 2 Splits</Statistic.Label>
          <Statistic.Value>{splits2}</Statistic.Value>
        </Statistic>
      </Statistic.Group>
    </Segment>
  )

}



const IncomeHistoryList = ({loading, data}) => {

  if(!data){ data = []};

  data = data.map(function(i){
    if(i.business.indexOf("transfer") != -1){
      i.business = "insite transfer";
    }
    return i
  });

  const usdt_balance      = data.filter((i)=>{return  i.asset == "usdt" }).map(function(i){
    if(i.business == "system:split:level1"){
      i.business = "Level 1 Split"
    }
    if(i.business == "system:split:level2"){
      i.business = "Level 2 Split"
    }
    return i
  });

  return (
    <Fragment>

      <Header as='h2' color="black">
        <Header.Content>Income Events</Header.Content>
        <Header.Subheader>Share GLaDOS and Get Splits</Header.Subheader>
      </Header>

      <Balance/>

      <Link to="/console/invite">
        <Button primary>Invite Friends</Button>
      </Link>

      <Link to="/console/withdraws">
        <Button secondary>Withdraw</Button>
      </Link>

      {usdt_balance.length == 0 ?
      <Segment placeholder>
        <Header icon>
          <Icon name='calendar' color="blue" />
          {loading?"Loading":"You don't have any split/withdraw events."}
        </Header>
        <Segment.Inline>
          <Link to="/console/invite">
            <Button primary>Invite Friends</Button>
          </Link>
        </Segment.Inline>
    </Segment>:<Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>Events</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>

        {usdt_balance.map((item)=>{
          return (
            <Table.Row key={item.id}>
              <Table.Cell collapsing>
                <Icon name='dollar' color={item.change>0?"green":"red"} /> {item.change}
              </Table.Cell>
              <Table.Cell>{readableMap[item.business]?readableMap[item.business]:item.business}</Table.Cell>
              <Table.Cell collapsing textAlign='right'>
                {ts2date(item.time)}
              </Table.Cell>
            </Table.Row>
          )
        })}

      </Table.Body>
    </Table>
  }

  </Fragment>
  );
}

const IncomeHistory = ListFactory(() => {
  console.log("get balance");
  return axios.get('/user/balance')
})(IncomeHistoryList);

class Income extends Component {

  constructor(){
    super(...arguments);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <IncomeHistory/>
  }
}

export default Income;
